export const BenefitsSection = ({ content }) => {
  if (!content.items?.length) return null;
  return (
    <section className="py-16 bg-background" data-testid="benefits-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {content.eyebrow && (
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-primary mb-2">{content.eyebrow}</p>
        )}
        <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-foreground mb-8">
          {content.heading}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {content.items.map((item, i) => (
            <div key={i} className="bg-card border border-border rounded-md p-6" data-testid={`benefit-item-${i}`}>
              <span className="font-display text-2xl font-black text-primary block mb-3">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="font-display text-base font-bold uppercase text-foreground mb-2">{item.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
